<template>
    <!-- https://tailwindui.com/components/application-ui/lists/grid-lists#component-5d72b187beb968e12db89fe49f272b18 -->
    <li     class="flex flex-col col-span-1 text-center bg-white rounded-lg shadow"
            :class="[{'bg-green-50' : isGood && !isSaving},{'bg-yellow-50' : isSaving}]">
        <div class="flex flex-col flex-1 px-8 py-4">
            <!--            <img class="shrink-0 w-32 h-32 mx-auto bg-black rounded-full" src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&amp;ixid=eyJhcHBfaWQiOjEyMDd9&amp;auto=format&amp;fit=facearea&amp;facepad=4&amp;w=256&amp;h=256&amp;q=60" alt="">-->
            <p class="mt-6 mb-0 font-medium text-md text-gray-1000">{{ getNonDefaultName() === '' ? 'Input ' + point.inputNumber : getNonDefaultName()}}</p>
            <div class="w-full mb-4 grid grid-cols-2">
                <span
                      class="sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-1 w-auto px-2 py-1 text-sm font-bold">{{point.probe_serial}}</span>
                <span :class="pillColorBasedOnInputNumber"
                      class="sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-1 rounded-full w-1/2 mx-auto px-2 py-1 text-sm font-bold">Input {{ inputNumber }}</span>
            </div>
            <div class="grid grid-cols-2 mt-1 mb-2">
                <div class="sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-1 text-sm leading-5 text-gray-500">
<!--                    <span class="mr-2 text-xs font-light text-grey-800"></span>-->
                    <span class="text-gray-500">{{ probeType ? probeType : 'Unknown Probe Type' }}</span>
                </div>
                <div    v-show="hasLoaded"
                        class="sm:col-span-2 md:col-span-2 lg:col-span-2 xl:col-span-1 p-1 text-xs font-medium leading-4 leading-5 text-teal-800 bg-green-100 rounded-full"
                        :class="isGood ? 'bg-green-100' : 'bg-green-50'">
                    Checked in {{lastCheckinTime}}
                </div>
            </div>
            <div class="mt-2 flex flex-wrap items-start text-sm leading-5 text-black-500">
                <span class="truncate w-full text-md"> {{ getZoneArea().area }}</span>
                <span class="truncate w-full text-md font-semibold">{{ getZoneArea().zone }}</span>
            </div>
        </div>

        <div v-if="probeType === 'Sonicu DPS'"
            class="mb-4">
                <span>
                    <a      class="my-2 text-blue-700 hover:text-blue-400 focus:text-blue-700 focus:no-underline"
                            href="https://support.sonicu.com/differential-air-pressure-quick-start-guide"
                            target="_blank">
                        Install Instructions for DPS Device
                    </a>
                </span>
        </div>

        <div    class="border-t border-gray-200"
                :class="isGood ? 'border-gray-300' : 'border-gray-200'">
            <div class="flex -mt-px">
                <div class="flex flex-1 w-0 border-gray-200">
                    <div v-if="isGood"
                         @click="reset(point.probe_serial)"
                         class="relative inline-flex items-center justify-center flex-1 w-0 py-4 text-sm font-medium leading-5 text-gray-700 border border-transparent rounded-bl-lg cursor-pointer hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10">
                        <span class="lnr icon-undo2"></span>
                        <span class="ml-3">Reset</span>
                    </div>
                    <div v-else @click="confirm(point.probe_serial)"
                         class="relative inline-flex items-center justify-center flex-1 w-0 py-4 text-sm font-medium leading-5 text-gray-700 border border-transparent rounded-bl-lg cursor-pointer hover:text-gray-500 focus:outline-none focus:ring-blue-200 focus:border-blue-300 focus:z-10">
                        <span class="lnr icon-check"></span>
                        <span class="ml-3">Confirm Install</span>
                    </div>
                </div>
            </div>
        </div>
    </li></template>

<script>
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
    import axios from "axios";

    export default {
        name: "InstallWizardPhysicalInstallCard",
        mixins: [SonicuCoreMixin],
        props: {
            point: Object,
            areaZones: Object,
            isFinished: Boolean,
        },
        data() {
            return {
                deviceName: this.getNonDefaultName(),
                savedDeviceName: this.getNonDefaultName(),
                zone: this.getZoneDefault(),
                lastCheckinTime: '',
                hasLoaded: false,
                meter: null,
                isGood: this.isFinished,
                isSaving: false,
            }
        },
        mounted() {
            this.getDeviceData();
        },
        methods: {
            confirm(serial) {
                this.isSaving = true
                axios.put(this.company.buildCompanyApiInternalRoute('wizard/physical-install/' + this.point.ID),
                    {
                        type: 'confirm',
                    }
                ).then(
                    response => {
                        this.isGood = response.data;
                        this.isSaving = false
                    }
                ).catch(
                    error => {
                        this.isSaving = false
                    }
                )
            },
            reset(serial) {
                this.isSaving = true
                axios.put(this.company.buildCompanyApiInternalRoute('wizard/physical-install/' + this.point.ID),
                    {
                        type: 'reset',
                    }
                ).then(
                    response => {
                        this.isGood = !response.data
                        this.isSaving = false
                    }
                ).catch(
                    error => {
                        this.isSaving = false
                    }
                )
            },
            getDeviceData(){
                axios
                    .get(this.company.buildCompanyApiInternalRoute('meters/' + this.point.meter.ID))
                    .then(response =>{
                        this.meter = response.data.data;
                        this.lastCheckinTime = response.data.data.lastCheckinTimeReadable;
                        this.hasLoaded = true;
                        setTimeout(this.getDeviceData, _.random(35000, 55000, false));
                    });
            },
            getNonDefaultName(){
                if(this.point.meter.is_default_name){
                    return '';
                }
                if(this.point.meter === null){
                    return '';
                }
                return this.point.meter.Name;
            },
            getZoneDefault(){
                return this.point.meter.ZoneID.toString();
            },
            getZoneArea() {
                let zoneId = this.point.meter.ZoneID
                let info = {}
                Object.keys(this.areaZones).forEach((areaName) => {
                    Object.keys(this.areaZones[areaName]).forEach((id) => {
                        if (Number.parseInt(id) === Number.parseInt(zoneId)) {
                            info = {
                                zone: this.areaZones[areaName][id],
                                area: areaName,
                            }
                        }
                    })
                })
                return info
            }
        },
        computed: {
            probeType(){
                if(this.point.probe !== undefined && this.point.probe !== null){
                    return this.point.probe.probe_type;
                }
                return null;
            },
            inputNumber() {
                return this.point.inputNumber;
            },
            pillColorBasedOnInputNumber() {
                if (this.inputNumber === 1) {
                    return 'bg-blue-100 text-blue-800';
                }
                if (this.inputNumber === 2) {
                    return 'bg-green-100 text-green-800';
                }
                if (this.inputNumber === 3) {
                    return 'bg-yellow-100 text-yellow-800';
                }
                if (this.inputNumber === 4) {
                    return 'bg-red-100 text-red-800';
                }
            }
        },

    }
</script>

<style scoped>

</style>